import { AgeConfirmTable } from './AgeConfirmTable'
import { withAgeConfirmTable } from './withAgeConfirmTable'

const ConnectedAgeConfirmTable = withAgeConfirmTable(AgeConfirmTable)
export { ConnectedAgeConfirmTable as AgeConfirmTable }
